export const colors = {
  black: "#000",
  white: "#fff",
  grey: "#727272",
  error: "#FF1B1C",
}
